/**
 * Custom hook to identify if a user just logged in and log some identity data
 */

import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import useSWR from 'swr';

import { disruptionAlertsState } from '@/state/disruption-alerts';
import { DisruptionAlertsDataInterface } from '@/types/database-types';
import { request } from '@/utils/api/request';
import { getDisruptionAlertsUrl } from '@/utils/helpers/api-urls';

export const useDisruptionAlerts = () => {
  const setAlerts = useSetRecoilState(disruptionAlertsState);

  const { data } = useSWR<DisruptionAlertsDataInterface>(getDisruptionAlertsUrl, request, {
    revalidateOnFocus: false,
  });

  useEffect(() => {
    if (data?.data) {
      setAlerts(data.data);
    }
  }, [data?.data]);
};
